<template>
  <div class="home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png" class="nav-icon-left" />
        <div>{{ $t('Back') }}</div>
      </div>
    </div>

    <div class="mission-content ac crfff">
      <div class="fs50 mt50">{{ $t('ai_bag_title') }}</div>
      <div class="css-1asaykn mt50 makeup-wrap">
        <div class="makeup-section-stack">
          <div class="desc-card">
            <div class="desc-text">{{ $t('ai_bag_tip') }}</div>
          </div>

          <div class="upload-card">
            <div class="upload-block">
              <div class="section-title fs26 fw7">{{ $t('bag_user_photo_title') }}</div>
              <div class="upload-top-row mt18">
                <div class="upload-left">
                  <label class="pick-photo-btn">
                    <input accept="image/*" type="file" class="hidden-input" @change="convertToBase64($event, 'source')">
                    <img class="pick-photo-icon" src="../../static/images/transparent.png" alt="" />
                    <span>{{ $t('Upload') }}</span>
                  </label>
                  <div class="upload-hint fs22 cr999 mt10" v-if="!sourceImageBase64">{{ $t('bag_user_photo_hint') }}</div>
                </div>
                <div v-if="sourceImageBase64" class="thumb-preview">
                  <img :src="sourceImageBase64" alt="source preview" />
                </div>
              </div>

              <div class="example-gallery mt18" v-if="exampleImages.length">
                <div class="example-gallery-title">{{ $t('upload_examples') }}</div>
                <div class="example-gallery-list">
                  <button
                    v-for="(item, index) in exampleImages"
                    :key="item + '_' + index"
                    class="example-thumb-btn"
                    @click="openExamplePreview(item)"
                  >
                    <img :src="item" class="example-thumb-img" alt="example" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="preset-card">
            <div class="section-title fs26 fw7">{{ $t('bag_gender_title') }}</div>
            <div class="section-subtitle fs22 mt10">{{ $t('bag_gender_tip') }}</div>

            <div class="body-part-list mt24">
              <button
                v-for="item in genderOptions"
                :key="item.value"
                type="button"
                class="body-part-item"
                :class="{ active: selectedGender === item.value }"
                @click="selectedGender = item.value"
              >
                <span class="body-part-radio"></span>
                <span class="body-part-label">{{ item.label }}</span>
              </button>
            </div>
          </div>

          <div class="upload-card">
            <div class="section-title fs26 fw7">{{ $t('bag_reference_title') }}</div>
            <div class="section-subtitle fs22 mt10">{{ $t('bag_reference_hint') }}</div>

            <div class="reference-tab-list mt24">
              <button
                v-for="item in referenceTabs"
                :key="item.value"
                type="button"
                class="reference-tab"
                :class="{ active: referenceMode === item.value }"
                @click="changeReferenceMode(item.value)"
              >
                {{ item.label }}
              </button>
            </div>

            <div v-if="referenceMode === 'upload'" class="reference-pane mt24">
              <div class="upload-top-row">
                <div class="upload-left">
                  <label class="pick-photo-btn">
                    <input accept="image/*" type="file" class="hidden-input" @change="convertToBase64($event, 'reference_upload')">
                    <img class="pick-photo-icon" src="../../static/images/transparent.png" alt="" />
                    <span>{{ $t('Upload') }}</span>
                  </label>
                  <div class="upload-hint fs22 cr999 mt10" v-if="!referenceUploadBase64">{{ $t('bag_reference_upload_hint') }}</div>
                </div>
                <div v-if="referenceUploadPreviewUrl" class="thumb-preview thumb-preview-reference">
                  <img :src="referenceUploadPreviewUrl" alt="reference upload preview" />
                </div>
              </div>
            </div>

            <div v-else class="reference-pane mt24">
              <div class="sample-grid-preview">
                <button
                  v-for="item in samplePreviewItems"
                  :key="item.id"
                  type="button"
                  class="sample-item"
                  :class="{ active: selectedSampleTemplate && selectedSampleTemplate.id === item.id }"
                  @click="selectSampleTemplate(item)"
                >
                  <img :src="item.image" alt="sample template" />
                </button>
              </div>

              <div class="sample-more-row" v-if="currentSampleTemplates.length > samplePreviewItems.length">
                <button class="sample-more-btn" type="button" @click="openSampleModal">{{ $t('bag_sample_see_all') }}</button>
              </div>

              <div class="selected-summary" :class="{ compact: !selectedSampleTemplate }">
                <div class="selected-summary-title fs24">{{ $t('bag_selected_reference') }}</div>
                <div v-if="selectedSampleTemplate" class="selected-chip-list mt18">
                  <div class="selected-chip" @click="openSampleModal">
                    <div class="selected-chip-thumb">
                      <img :src="selectedSampleTemplate.image" alt="selected template" />
                    </div>
                    <div class="selected-chip-main">
                      <span class="selected-chip-name">{{ selectedSampleTemplate.title }}</span>
                    </div>
                    <button class="selected-chip-remove" @click.stop="removeSelectedSampleTemplate">x</button>
                  </div>
                </div>
                <div v-else class="selected-empty mt18">{{ $t('bag_selected_reference_empty') }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="ac mt50">
          <button class="generate-btn" :class="{ disabled: !canSubmit }" :disabled="!canSubmit" @click="submitBag">
            <strong>{{ $t('Generate') }}</strong>
          </button>
        </div>

        <div class="flex chances-info-bar mt30" style="justify-content: space-between;">
          <div class="score-badge">
            <span class="fs24">{{ $t('ChancesLeft') }}</span>
            <span class="fs32 fw7 ml10">{{ score }}</span>
          </div>
          <button class="buy-btn" @click="goPurchaseChances">
            <span>{{ $t('BuyChances') }}</span>
            <img src="../../static/images/buy.png" class="buy-icon" >
          </button>
        </div>
      </div>
    </div>

    <Dialog ref="processDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert" width="100">
      <div slot="mdBox" class="alert-modal ac">
        <div class="fs33 mt50 ac">{{ processMsg }}</div>
        <div class="alert-actions mt30">
          <button class="button" @click="closeProcessDialog">{{ $t('OK') }}</button>
          <button v-if="processCanGoHistory" class="button history-btn ml20" @click="goHistoryFromDialog">{{ $t('History') }}</button>
        </div>
      </div>
    </Dialog>

    <Dialog ref="resultDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert" width="100">
      <div slot="mdBox" class="alert-modal result-modal">
        <div class="result-modal-close" @click="closeResultDialog">×</div>
        <div class="result-modal-tip mt18">{{ $t('downTips1') }}</div>
        <div class="result-modal-image mt20">
          <img v-if="resultPreviewTab === 1" :src="resultGeneratedUrl" alt="generated result" />
          <img v-else :src="resultOriginalUrl" alt="original result" />
        </div>
        <div class="result-modal-tabs mt24">
          <span :class="{ active: resultPreviewTab === 1 }" @click="resultPreviewTab = 1">{{ $t('Result') }}</span>
          <span :class="{ active: resultPreviewTab === 2 }" @click="resultPreviewTab = 2">{{ $t('Original') }}</span>
        </div>
        <div class="result-link-bar mt24">
          <input class="result-link-input" :value="currentResultUrl" disabled type="text">
          <button
            id="copyBagResultLink"
            class="result-copy-btn"
            :data-clipboard-text="currentResultUrl"
            @click="copyResultLink"
          >
            <img src="../../static/images/Copy.png" alt="copy" />
          </button>
        </div>
      </div>
    </Dialog>

    <div v-if="generatingVisible" class="generating-mask">
      <div class="generating-panel">
        <div class="generating-orbit">
          <span class="orbit-ring ring-one"></span>
          <span class="orbit-ring ring-two"></span>
          <span class="orbit-core"></span>
          <span class="orbit-dot dot-one"></span>
          <span class="orbit-dot dot-two"></span>
          <span class="orbit-dot dot-three"></span>
        </div>
        <div class="generating-title mt30">{{ $t('bag_generating_title') }}</div>
        <div class="generating-desc mt15">{{ $t('bag_generating_desc') }}</div>
        <div class="generating-progress mt20">
          <span>{{ $t('bag_generating_wait') }}</span>
          <strong>{{ generatingCountdown }}s</strong>
        </div>
      </div>
    </div>

    <div v-if="showSampleModal" class="preset-modal-mask" @click.self="closeSampleModal">
      <div class="preset-modal-panel">
        <div class="preset-modal-head">
          <div>
            <div class="preset-modal-title">{{ $t('bag_sample_modal_title') }}</div>
          </div>
          <button class="preset-modal-close" @click="closeSampleModal">x</button>
        </div>

        <div class="preset-modal-body">
          <div class="preset-grid">
            <button
              v-for="item in visibleSampleModalItems"
              :key="item.id"
              type="button"
              class="preset-item"
              :class="{ active: selectedSampleTemplate && selectedSampleTemplate.id === item.id }"
              @click="selectSampleTemplate(item)"
            >
              <div class="preset-image-wrap">
                <img :src="item.image" class="preset-image" :alt="item.title" />
                <div class="preset-image-mask"></div>
                <div class="preset-check" v-if="selectedSampleTemplate && selectedSampleTemplate.id === item.id">v</div>
              </div>
              <div class="preset-content">
                <div class="preset-title">{{ item.title }}</div>
              </div>
            </button>
          </div>

          <div class="ac load-more-wrap" v-if="hasMoreSampleModalItems">
            <button class="more-btn" @click="loadMoreSampleItems">{{ $t('makeup_load_more') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="examplePreviewVisible" class="example-preview-mask" @click.self="closeExamplePreview">
      <div class="example-preview-panel">
        <button class="example-preview-close" @click="closeExamplePreview">×</button>
        <img :src="activeExampleImage" class="example-preview-image" alt="example preview" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import Clipboard from 'clipboard'
import aiBagCatalog from '../constants/aiBagCatalog'

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      sourceImageBase64: null,
      sourceImageType: '',
      score: 0,
      processMsg: '',
      processCanGoHistory: false,
      selectedGender: 'female',
      referenceMode: 'sample',
      referenceUploadBase64: null,
      referenceUploadType: '',
      referenceUploadPreviewUrl: '',
      selectedSampleTemplate: null,
      sampleReferenceBase64: null,
      sampleReferenceType: '',
      sampleModalVisibleCount: 12,
      showSampleModal: false,
      generatingVisible: false,
      generatingTaskId: '',
      generatingCountdown: 60,
      generatingTimer: null,
      generatingCountdownTimer: null,
      resultGeneratedUrl: '',
      resultOriginalUrl: '',
      resultPreviewTab: 1,
      pendingOriginalPreview: '',
      exampleImages: [
        '/static/images/ai_bag/person_female_01.jpg',
        '/static/images/ai_bag/person_female_02.jpg',
        '/static/images/ai_bag/person_male_01.jpg',
      ],
      examplePreviewVisible: false,
      activeExampleImage: ''
    }
  },
  computed: {
    genderOptions() {
      return [
        { value: 'female', label: this.$t('Female') },
        { value: 'male', label: this.$t('Male') }
      ]
    },
    referenceTabs() {
      return [
        { value: 'upload', label: this.$t('bag_reference_tab_upload') },
        { value: 'sample', label: this.$t('bag_reference_tab_sample') }
      ]
    },
    currentSampleTemplates() {
      return aiBagCatalog.all || []
    },
    samplePreviewItems() {
      return this.currentSampleTemplates.slice(0, 6)
    },
    visibleSampleModalItems() {
      return this.currentSampleTemplates.slice(0, this.sampleModalVisibleCount)
    },
    hasMoreSampleModalItems() {
      return this.currentSampleTemplates.length > this.visibleSampleModalItems.length
    },
    activeReferenceBase64() {
      return this.referenceMode === 'sample' ? this.sampleReferenceBase64 : this.referenceUploadBase64
    },
    activeReferenceType() {
      return this.referenceMode === 'sample' ? this.sampleReferenceType : this.referenceUploadType
    },
    canSubmit() {
      return !!(this.sourceImageBase64 && this.activeReferenceBase64 && this.selectedGender)
    },
    currentResultUrl() {
      return this.resultGeneratedUrl
    }
  },
  created() {
    this.getHome()
  },
  beforeDestroy() {
    this.stopGeneratingPolling()
    this.lockBodyScroll(false)
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getHome() {
      let that = this
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        })
      })
    },
    convertToBase64(event, target) {
      const file = event.target.files[0]
      if (!file) return
      const maxSize = 10 * 1024 * 1024
      if (file.size > maxSize) {
        this.$refs.processDialog.showMaskFun()
        this.processMsg = this.$t('pic_size_limit')
        event.target.value = ''
        return
      }
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          const maxWidth = 1000
          const maxHeight = 1000
          let { width, height } = img
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width
              width = maxWidth
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height
              height = maxHeight
            }
          }
          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0, width, height)
          let outputType = file.type.toLowerCase() === 'image/png' ? 'image/png' : 'image/jpeg'
          const base64 = canvas.toDataURL(outputType, 0.8)
          const imageType = outputType.split('/')[1]
          if (target === 'reference_upload') {
            this.removeSelectedSampleTemplate()
            this.referenceUploadBase64 = base64
            this.referenceUploadType = imageType
            this.referenceUploadPreviewUrl = base64
            this.referenceMode = 'upload'
          } else {
            this.sourceImageBase64 = base64
            this.sourceImageType = imageType
          }
        }
      }
      reader.readAsDataURL(file)
      event.target.value = ''
    },
    changeReferenceMode(value) {
      if (this.referenceMode !== value) {
        this.clearReferenceSelection()
      }
      this.referenceMode = value
      if (value === 'upload') {
        this.closeSampleModal()
      }
      this.syncBodyLock()
    },
    async loadSampleImageAsBase64(imageUrl) {
      const response = await fetch(imageUrl)
      const blob = await response.blob()
      const extension = (blob.type || '').indexOf('png') > -1 ? 'png' : 'jpeg'
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          resolve({
            base64: reader.result,
            type: extension
          })
        }
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    async selectSampleTemplate(item) {
      try {
        const result = await this.loadSampleImageAsBase64(item.image)
        this.referenceUploadBase64 = null
        this.referenceUploadType = ''
        this.referenceUploadPreviewUrl = ''
        this.selectedSampleTemplate = item
        this.sampleReferenceBase64 = result.base64
        this.sampleReferenceType = result.type
        this.referenceMode = 'sample'
        this.closeSampleModal()
      } catch (error) {
        this.$utils.alertText(this.$t('Generated failed'), 80)
      }
    },
    removeSelectedSampleTemplate() {
      this.selectedSampleTemplate = null
      this.sampleReferenceBase64 = null
      this.sampleReferenceType = ''
    },
    clearReferenceSelection() {
      this.referenceUploadBase64 = null
      this.referenceUploadType = ''
      this.referenceUploadPreviewUrl = ''
      this.removeSelectedSampleTemplate()
    },
    openSampleModal() {
      this.showSampleModal = true
      this.syncBodyLock()
    },
    closeSampleModal() {
      this.showSampleModal = false
      this.syncBodyLock()
    },
    loadMoreSampleItems() {
      this.sampleModalVisibleCount += 12
    },
    submitBag() {
      let that = this
      if (!that.sourceImageBase64) {
        that.$utils.alertText(that.$t('bag_user_photo_title'), 100)
        return
      }
      if (!that.activeReferenceBase64) {
        that.$utils.alertText(that.$t('bag_reference_title'), 100)
        return
      }
      if (!that.selectedGender) {
        that.$utils.alertText(that.$t('bag_gender_title'), 100)
        return
      }

      let data = {
        image: {
          type: that.sourceImageType,
          content: that.sourceImageBase64
        },
        ref_image: {
          type: that.activeReferenceType,
          content: that.activeReferenceBase64
        },
        gender: that.selectedGender
      }

      that.pendingOriginalPreview = that.sourceImageBase64
      that.$parent.loadModal(true)
      that.$api.post('/api/you_cam/bag_vto', data, r => {
        that.$parent.loadModal(false)
        that.getHome()
        if (r.code == 1) {
          const responseData = r.data || {}
          if (responseData.status === true && responseData.url) {
            that.handleGenerateSuccess(responseData.url)
            return
          }
          if (responseData.task_id) {
            that.startGeneratingPolling(responseData.task_id)
            return
          }
          that.processCanGoHistory = false
          that.$refs.processDialog.showMaskFun()
          that.processMsg = r.msg
        } else {
          that.$utils.alertText(r.msg, 50)
        }
      })
    },
    closeProcessDialog() {
      this.processMsg = ''
      this.processCanGoHistory = false
      this.$refs.processDialog.closeMask()
    },
    openResultDialog() {
      this.resultPreviewTab = 1
      this.$refs.resultDialog.showMaskFun()
    },
    closeResultDialog() {
      this.$refs.resultDialog.closeMask()
    },
    copyResultLink() {
      const clipboard = new Clipboard('#copyBagResultLink')
      clipboard.on('success', () => {
        this.$utils.alertText(this.$t('CopySucceeded'))
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        clipboard.destroy()
      })
    },
    openExamplePreview(image) {
      this.activeExampleImage = image
      this.examplePreviewVisible = true
      this.syncBodyLock()
    },
    closeExamplePreview() {
      this.examplePreviewVisible = false
      this.activeExampleImage = ''
      this.syncBodyLock()
    },
    lockBodyScroll(locked) {
      document.body.style.overflow = locked ? 'hidden' : ''
    },
    syncBodyLock() {
      this.lockBodyScroll(this.showSampleModal || this.generatingVisible || this.examplePreviewVisible)
    },
    startGeneratingPolling(taskId) {
      this.stopGeneratingPolling()
      this.generatingTaskId = taskId
      this.generatingCountdown = 60
      this.generatingVisible = true
      this.syncBodyLock()
      this.pollGeneratingTask()
      this.generatingTimer = setInterval(() => {
        this.pollGeneratingTask()
      }, 5000)
      this.generatingCountdownTimer = setInterval(() => {
        this.generatingCountdown -= 1
        if (this.generatingCountdown <= 0) {
          this.handleGeneratingTimeout()
        }
      }, 1000)
    },
    stopGeneratingPolling() {
      if (this.generatingTimer) {
        clearInterval(this.generatingTimer)
        this.generatingTimer = null
      }
      if (this.generatingCountdownTimer) {
        clearInterval(this.generatingCountdownTimer)
        this.generatingCountdownTimer = null
      }
      this.generatingTaskId = ''
      this.generatingVisible = false
      this.generatingCountdown = 60
      this.syncBodyLock()
    },
    pollGeneratingTask() {
      let that = this
      if (!that.generatingTaskId) return
      that.$api.post('/api/you_cam/check_process', { task_id: that.generatingTaskId }, r => {
        if (r.code !== 1) {
          return
        }
        const responseData = r.data || {}
        if (responseData.status === 'success' && responseData.url) {
          that.stopGeneratingPolling()
          that.handleGenerateSuccess(responseData.url)
          that.getHome()
          return
        }
        if (responseData.status === 'failed') {
          that.stopGeneratingPolling()
          that.getHome()
          that.processCanGoHistory = false
          that.$refs.processDialog.showMaskFun()
          that.processMsg = that.$t('Generated failed')
        }
      })
    },
    handleGeneratingTimeout() {
      this.stopGeneratingPolling()
      this.processCanGoHistory = true
      this.processMsg = this.$t('bag_timeout_tip')
      this.$refs.processDialog.showMaskFun()
    },
    handleGenerateSuccess(url) {
      this.resultGeneratedUrl = url
      this.resultOriginalUrl = this.pendingOriginalPreview || this.sourceImageBase64
      this.sourceImageBase64 = null
      this.sourceImageType = ''
      this.referenceUploadBase64 = null
      this.referenceUploadType = ''
      this.referenceUploadPreviewUrl = ''
      this.removeSelectedSampleTemplate()
      this.pendingOriginalPreview = ''
      this.referenceMode = 'sample'
      this.selectedGender = 'female'
      this.sampleModalVisibleCount = 12
      this.openResultDialog()
    },
    goHistoryFromDialog() {
      this.closeProcessDialog()
      this.$router.push({ path: '/history' })
    },
    goPurchaseChances() {
      this.$router.push({ path: '/purchaseChances' })
    }
  }
}
</script>

<style scoped>
.makeup-wrap {
  padding: 0 0.3rem;
  text-align: left;
}
.desc-card,
.upload-card,
.preset-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0.22rem;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.18);
}
.makeup-section-stack {
  display: flex;
  flex-direction: column;
  gap: 0.34rem;
}
.desc-card {
  padding: 0.34rem 0.28rem;
}
.desc-text {
  font-size: 0.26rem;
  line-height: 1.72;
  color: rgba(255, 255, 255, 0.88);
}
.upload-card,
.preset-card {
  padding: 0.4rem 0.28rem;
}
.section-title {
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.35;
}
.section-subtitle {
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.62;
}
.upload-card .section-subtitle,
.preset-card .section-subtitle {
  margin-top: 0.16rem;
}
.upload-card {
  display: flex;
  flex-direction: column;
}
.upload-block {
  display: flex;
  flex-direction: column;
}
.upload-top-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.26rem;
}
.upload-block .upload-top-row {
  margin-top: 0.22rem;
}
.upload-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  flex: 1;
}
.pick-photo-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.18rem 0.32rem;
  background: rgba(26, 75, 169, 0.12);
  border: 1px dashed rgba(26, 75, 169, 0.55);
  border-radius: 0.18rem;
  color: #fff;
  font-size: 0.26rem;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.pick-photo-icon {
  width: 0.36rem;
  height: 0.36rem;
}
.hidden-input {
  display: none;
}
.example-gallery-title {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.22rem;
  line-height: 1.4;
  margin-bottom: 0.22rem;
  margin-top: 0.22rem;
}
.example-gallery-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.14rem;
  width: 100%;
}
.example-thumb-btn {
  width: 100%;
  aspect-ratio: 0.8 / 1;
  padding: 0;
  border: none;
  border-radius: 0.16rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0.08rem 0.18rem rgba(0, 0, 0, 0.18);
}
.example-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.thumb-preview {
  width: 1.08rem;
  height: 1.08rem;
  align-self: center;
  border-radius: 0.16rem;
  overflow: hidden;
  border: 2px solid rgba(26, 75, 169, 0.35);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.06);
}
.thumb-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.thumb-preview-reference {
  width: 1.18rem;
  height: 1.18rem;
}
.preset-card {
  padding-top: 0.4rem;
  padding-bottom: 0.44rem;
}
.body-part-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem 0.22rem;
  margin-top: 0.22rem;
}
.body-part-item {
  min-height: 0.7rem;
  padding: 0.12rem 0.18rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  display: inline-flex;
  align-items: center;
  gap: 0.12rem;
  color: rgba(255, 255, 255, 0.82);
  -webkit-tap-highlight-color: transparent;
}
.body-part-item.active {
  border-color: rgba(26, 75, 169, 0.85);
  background: rgba(26, 75, 169, 0.16);
  color: #fff;
}
.body-part-radio {
  width: 0.22rem;
  height: 0.22rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.45);
  position: relative;
  flex: 0 0 auto;
}
.body-part-item.active .body-part-radio {
  border-color: #8db2ff;
}
.body-part-item.active .body-part-radio::after {
  content: '';
  position: absolute;
  inset: 0.04rem;
  border-radius: 50%;
  background: #8db2ff;
}
.body-part-label {
  font-size: 0.23rem;
  line-height: 1.35;
  font-weight: 700;
}
.reference-tab-list {
  display: flex;
  align-items: center;
  gap: 0.16rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 0.14rem;
}
.reference-tab {
  position: relative;
  padding: 0 0.06rem 0.14rem;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.24rem;
  font-weight: 700;
  -webkit-tap-highlight-color: transparent;
}
.reference-tab.active {
  color: #fff;
}
.reference-tab.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.13rem;
  height: 0.04rem;
  border-radius: 0.02rem;
  background: #3d84ff;
}
.reference-pane {
  display: flex;
  flex-direction: column;
}
.upload-card .reference-pane,
.upload-card .reference-tab-list {
  margin-top: 0.26rem;
}
.sample-grid-preview {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.2rem;
}
.sample-item {
  padding: 0;
  border-radius: 0.18rem;
  border: 2px solid transparent;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.06);
  aspect-ratio: 0.84 / 1;
  -webkit-tap-highlight-color: transparent;
}
.sample-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.sample-item.active {
  border-color: #4c87ff;
  box-shadow: 0 0 0 2px rgba(76, 135, 255, 0.16);
}
.sample-more-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.2rem;
}
.sample-more-btn {
  border: none;
  background: transparent;
  color: #6ea3ff;
  font-size: 0.24rem;
  font-weight: 700;
  -webkit-tap-highlight-color: transparent;
}
.selected-summary {
  margin-top: 0.32rem;
  padding: 0.24rem 0.22rem;
  border-radius: 0.18rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.selected-summary.compact {
  padding-bottom: 0.22rem;
}
.selected-summary-title {
  color: rgba(255, 255, 255, 0.92);
  font-weight: 700;
}
.selected-chip-list {
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
}
.selected-chip {
  display: flex;
  align-items: center;
  gap: 0.16rem;
  padding: 0.2rem;
  border-radius: 0.16rem;
  background: rgba(26, 75, 169, 0.12);
  border: 1px solid rgba(26, 75, 169, 0.24);
}
.selected-chip-thumb {
  width: 0.92rem;
  height: 0.92rem;
  border-radius: 0.14rem;
  overflow: hidden;
  flex: 0 0 auto;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}
.selected-chip-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.selected-chip-main {
  min-width: 0;
  flex: 1 1 auto;
}
.selected-chip-name {
  display: block;
  font-size: 0.24rem;
  color: #fff;
  line-height: 1.35;
}
.selected-chip-remove {
  width: 0.46rem;
  height: 0.46rem;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 0.24rem;
  line-height: 1;
  flex: 0 0 auto;
}
.selected-empty {
  font-size: 0.24rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.55;
}
.generate-btn {
  width: 90%;
  height: 0.9rem;
  background: linear-gradient(135deg, #1A4BA9 0%, #0d2e6e 100%);
  color: #fff;
  border-radius: 0.45rem;
  border: none;
  font-size: 0.32rem;
  font-weight: 700;
  box-shadow: 0 6px 20px rgba(26, 75, 169, 0.4);
  cursor: pointer;
  transition: all 0.3s;
  -webkit-tap-highlight-color: transparent;
}
.generate-btn:active {
  transform: scale(0.96);
  box-shadow: 0 2px 10px rgba(26, 75, 169, 0.4);
}
.generate-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.chances-info-bar {
  display: flex;
  width: 100%;
  margin: 0 auto 0.4rem;
  background: rgba(255, 255, 255, 0.05);
  padding: 0.12rem 0.22rem;
  border-radius: 0.5rem;
  align-items: center;
  gap: 0.14rem;
}
.score-badge {
  display: flex;
  align-items: center;
  color: #fff;
  min-width: 0;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
}
.score-badge span {
  white-space: nowrap;
}
.score-badge span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.score-badge .fs24 {
  line-height: 1.35;
  padding: 0.02rem 0;
}
.buy-btn {
  background: #1A4BA9;
  border: none;
  color: #fff;
  padding: 0.12rem 0.24rem;
  border-radius: 0.3rem;
  font-size: 0.24rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(26, 75, 169, 0.3);
  -webkit-tap-highlight-color: transparent;
  flex: 0 1 48%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
}
.buy-btn span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.buy-icon {
  width: 0.28rem;
  margin-left: 0.15rem;
  flex: 0 0 auto;
}
.alert-modal {
  padding: 0.3rem 0.3rem 0.45rem;
  color: #fff;
}
.alert-actions {
  display: flex;
  align-items: center;
  justify-content: center;
}
.button {
  min-width: 1.8rem;
  height: 0.72rem;
  padding: 0 0.26rem;
  border-radius: 0.36rem;
  border: none;
  color: #fff;
  background: #1A4BA9;
  font-size: 0.26rem;
  font-weight: 700;
}
.history-btn {
  background: rgba(255, 255, 255, 0.12);
}
.result-modal {
  padding: 0.24rem 0.26rem 0.32rem;
  background: linear-gradient(180deg, rgba(33, 15, 78, 0.98) 0%, rgba(27, 13, 67, 0.98) 100%);
  border: 1px solid rgba(255, 63, 196, 0.72);
  border-radius: 0.2rem;
  box-shadow: 0 18px 46px rgba(0, 0, 0, 0.38);
}
.result-modal-close {
  text-align: right;
  color: #fff;
  font-size: 0.78rem;
  line-height: 1;
  font-weight: 300;
}
.result-modal-tip {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.3rem;
  line-height: 1.5;
  font-weight: 600;
}
.result-modal-image {
  border-radius: 0.22rem;
  overflow: hidden;
  background: transparent;
  width: auto;
  max-width: 82%;
  margin-left: auto;
  margin-right: auto;
}
.result-modal-image img {
  display: block;
  width: auto;
  max-width: 100%;
  max-height: 7.2rem;
  object-fit: contain;
  margin-left: auto;
  margin-right: auto;
}
.result-modal-tabs {
  display: flex;
  justify-content: center;
  gap: 0.18rem;
  margin-top: 20px;
}
.result-modal-tabs span {
  min-width: 1.58rem;
  padding: 0.16rem 0.26rem;
  border-radius: 0.14rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: transparent;
  color: rgba(255, 255, 255, 0.84);
  font-size: 0.24rem;
  font-weight: 700;
  text-align: center;
}
.result-modal-tabs span.active {
  color: #fff;
  border-color: rgba(43, 122, 255, 0.96);
  background: linear-gradient(180deg, #2c8cff 0%, #1565ff 100%);
  box-shadow: 0 8px 18px rgba(21, 101, 255, 0.28);
}
.result-link-bar {
  margin-top: 20px;
  width: 92%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  gap: 0.12rem;
  padding: 0.12rem;
  border-radius: 0.28rem;
  background: rgba(255, 255, 255, 0.06);
}
.result-link-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 0.76rem;
  padding: 0 0.22rem;
  border: none;
  outline: none;
  border-radius: 0.22rem;
  background: rgba(255, 255, 255, 0);
  color: #fff;
  font-size: 0.25rem;
  text-overflow: ellipsis;
}
.result-copy-btn {
  width: 0.82rem;
  height: 0.82rem;
  flex: 0 0 0.82rem;
  border: none;
  border-radius: 0.2rem;
  background: linear-gradient(135deg, #2d8fff 0%, #8b5dff 52%, #ff5ba7 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 24px rgba(95, 90, 255, 0.24);
}
.result-copy-btn img {
  width: 0.42rem;
  height: 0.42rem;
}
.generating-mask,
.preset-modal-mask {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(7, 11, 24, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
}
.generating-panel,
.preset-modal-panel {
  width: 100%;
  max-width: 6.4rem;
  border-radius: 0.28rem;
  background: linear-gradient(180deg, rgba(20, 28, 51, 0.98) 0%, rgba(10, 16, 31, 0.98) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.38);
}
.generating-panel {
  max-width: 6.2rem;
  padding: 0.48rem 0.36rem;
  text-align: center;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.42);
}
.generating-orbit {
  position: relative;
  width: 2.2rem;
  height: 2.2rem;
  margin: 0 auto;
}
.orbit-ring,
.orbit-core,
.orbit-dot {
  position: absolute;
  border-radius: 50%;
}
.orbit-ring {
  inset: 0;
  border: 1px solid rgba(115, 167, 255, 0.24);
}
.ring-one {
  animation: orbitSpin 6s linear infinite;
}
.ring-two {
  inset: 0.22rem;
  border-color: rgba(123, 99, 255, 0.3);
  animation: orbitSpinReverse 4.5s linear infinite;
}
.orbit-core {
  inset: 0.56rem;
  background: radial-gradient(circle, #5f93ff 0%, #254fae 65%, rgba(37, 79, 174, 0.25) 100%);
  box-shadow: 0 0 28px rgba(77, 136, 255, 0.55);
  animation: corePulse 1.8s ease-in-out infinite;
}
.orbit-dot {
  width: 0.2rem;
  height: 0.2rem;
  background: #fff;
  box-shadow: 0 0 14px rgba(255, 255, 255, 0.62);
}
.dot-one {
  top: 0.18rem;
  left: 50%;
  margin-left: -0.1rem;
  animation: floatDot 2.2s ease-in-out infinite;
}
.dot-two {
  right: 0.2rem;
  bottom: 0.42rem;
  width: 0.16rem;
  height: 0.16rem;
  background: #7b63ff;
  animation: floatDot 2.6s ease-in-out infinite 0.3s;
}
.dot-three {
  left: 0.28rem;
  bottom: 0.32rem;
  width: 0.14rem;
  height: 0.14rem;
  background: #4dc7ff;
  animation: floatDot 2.8s ease-in-out infinite 0.5s;
}
.generating-title {
  font-size: 0.38rem;
  color: #fff;
  font-weight: 700;
  line-height: 1.35;
}
.generating-desc {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.24rem;
  line-height: 1.55;
}
.generating-progress {
  display: inline-flex;
  align-items: center;
  gap: 0.14rem;
  padding: 0.14rem 0.22rem;
  border-radius: 0.32rem;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.23rem;
}
.generating-progress strong {
  color: #fff;
  font-size: 0.28rem;
}
.preset-modal-panel {
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.preset-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.16rem;
  padding: 0.24rem 0.24rem 0.18rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}
.preset-modal-title {
  font-size: 0.32rem;
  color: #fff;
  font-weight: 700;
}
.preset-modal-tip {
  margin-top: 0.14rem;
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.22rem;
  line-height: 1.45;
}
.preset-modal-close {
  width: 0.56rem;
  height: 0.56rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(16, 22, 40, 0.82);
  color: #fff;
  font-size: 0.28rem;
  line-height: 1;
}
.preset-modal-body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0.26rem 0.24rem 0.56rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}
.preset-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.18rem;
}
.preset-item {
  padding: 0;
  border-radius: 0.18rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
  appearance: none;
  -webkit-appearance: none;
  text-align: left;
  color: inherit;
}
.preset-item.active {
  border-color: rgba(26, 75, 169, 0.9);
  box-shadow: 0 0 0 2px rgba(26, 75, 169, 0.2);
}
.preset-image-wrap {
  position: relative;
  aspect-ratio: 0.82 / 1;
  background: rgba(255, 255, 255, 0.06);
}
.preset-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preset-image-mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.8rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.72));
  pointer-events: none;
}
.preset-content {
  padding: 0.16rem 0.16rem 0.18rem;
}
.preset-title {
  font-size: 0.25rem;
  font-weight: 700;
  color: #fff;
  line-height: 1.35;
}
.preset-check {
  position: absolute;
  top: 0.12rem;
  right: 0.12rem;
  width: 0.34rem;
  height: 0.34rem;
  border-radius: 50%;
  background: rgba(26, 75, 169, 0.92);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.18rem;
  font-weight: 700;
  pointer-events: none;
}
.more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.16rem 0.42rem;
  min-height: 0.72rem;
  min-width: 2.1rem;
  border: 1px solid rgba(26, 75, 169, 0.45);
  background: rgba(26, 75, 169, 0.12);
  color: #fff;
  border-radius: 0.32rem;
  font-size: 0.24rem;
}
.load-more-wrap {
  margin-top: 0.32rem;
  padding-top: 0.04rem;
  padding-bottom: 0.12rem;
}
.example-preview-mask {
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(7, 11, 24, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
}
.example-preview-panel {
  position: relative;
  width: 100%;
  max-width: 6.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.example-preview-close {
  position: absolute;
  top: -0.2rem;
  right: 0;
  width: 0.56rem;
  height: 0.56rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(16, 22, 40, 0.82);
  color: #fff;
  font-size: 0.28rem;
  line-height: 1;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
}
.example-preview-image {
  display: block;
  width: 100%;
  max-height: 84vh;
  object-fit: contain;
}
@keyframes orbitSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes orbitSpinReverse {
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
}
@keyframes corePulse {
  0%, 100% { transform: scale(0.95); box-shadow: 0 0 18px rgba(77, 136, 255, 0.4); }
  50% { transform: scale(1.05); box-shadow: 0 0 34px rgba(77, 136, 255, 0.68); }
}
@keyframes floatDot {
  0%, 100% { transform: translateY(0); opacity: 0.9; }
  50% { transform: translateY(-0.08rem); opacity: 1; }
}
</style>



// WEBPACK FOOTER //
// src/page/aiBag.vue